import ScopeConstants from "constants/ScopeConstants"
import ExpenseStatusConstants from "constants/ExpenseStatusConstants"

export const ExpenseAnyScope = {
    key: ScopeConstants.EXPENSE_ANY,
    selector: (state) => state.expensesAny,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Expense/SearchAny/",
    singleEndpoint: "/api/Expense/GetAny/",
    updateEndpoint: "/api/Expense/UpdateAny/",
    deleteEndpoint: "/api/Expense/DeleteAny/",
    defaultRecord: {
        name: "",
        code: "",
        status: ExpenseStatusConstants.DRAFT
    }
}